var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sale-loader--container p-4"},[_c('p',{staticClass:"text-center font-weight-bold loading-text"},[_vm._v("Services Loading...")]),_c('div',{staticClass:"loading"},[_c('div',{staticClass:"dot"}),_c('div',{staticClass:"dot"}),_c('div',{staticClass:"dot"})])])
}]

export { render, staticRenderFns }